import { LogoutOutlined, MessageOutlined } from "@ant-design/icons";
import { Avatar, Button, Flex, Layout, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";

import { logoutUser } from "../../api/auth.api";
import { useAuth } from "../../hooks/useAuth";
import Logo from "../../assets/logo-icon-transparent.png";

const TopBar = () => {
  const navigate = useNavigate();
  const { user, refreshToken, clearSession } = useAuth();

  const onLogout = async () => {
    try {
      await logoutUser(refreshToken);
    } catch (_error) {
      // Ignore logout failures so local session can still clear.
    } finally {
      clearSession();
      window.location.assign("/login");
    }
  };

  return (
    <Layout.Header className="app-topbar">
      <Flex justify="space-between" align="center" style={{ height: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img
            src={Logo}
            alt="ePost Global"
            style={{ height: "56px", width: "56px", objectFit: "contain" }}
          />
          <div>
            <Typography.Title level={4} className="app-topbar__title">
              LLM Monitoring
            </Typography.Title>
            <Typography.Text className="app-topbar__subtitle">
              Chatbot observability and access control
            </Typography.Text>
          </div>
        </div>
        <Space size="middle">
          <Button icon={<MessageOutlined />} onClick={() => navigate("/chat")}>
            Chatbot
          </Button>
          <Space
            align="center"
            style={{
              backgroundColor: "rgba(255,255,255,0.72)",
              borderRadius: "999px",
              padding: "4px 12px 4px 4px",
              gap: "8px",
            }}
          >
            <Avatar style={{ backgroundColor: "#4caf50", flexShrink: 0 }}>
              {user?.username?.slice(0, 1).toUpperCase()}
            </Avatar>
            <Typography.Text strong style={{ whiteSpace: "nowrap" }}>
              {user?.username}
            </Typography.Text>
          </Space>
          <Button icon={<LogoutOutlined />} onClick={onLogout}>
            Logout
          </Button>
        </Space>
      </Flex>
    </Layout.Header>
  );
};

export default TopBar;
